export enum OrderCheckoutType {
	POSTPAID = "postpaid", // Pós pago
	PREPAID = "prepaid", // Pré pago
	SUBSCRIPTION = "subscription", // Inscrição
}

export function getOrderCheckoutTypeName(checkout_type: OrderCheckoutType): string {
    switch (checkout_type) {
        case OrderCheckoutType.PREPAID:
            return OrderCheckoutTypeTagName.PREPAID;
		case OrderCheckoutType.POSTPAID:
			return OrderCheckoutTypeTagName.POSTPAID;
		case OrderCheckoutType.SUBSCRIPTION:
			return OrderCheckoutTypeTagName.SUBSCRIPTION;
        default:
            return 'Graduação';
    }
}

export function getCheckoutTypeSlug(checkout_type: OrderCheckoutTypeTagName): string {
    switch (checkout_type) {
        case OrderCheckoutTypeTagName.PREPAID:
            return OrderCheckoutType.PREPAID;
		case OrderCheckoutTypeTagName.POSTPAID:
			return OrderCheckoutType.POSTPAID;
		case OrderCheckoutTypeTagName.SUBSCRIPTION:
			return OrderCheckoutType.SUBSCRIPTION;
        default:
            return 'Graduação';
    }
}

export enum OrderCheckoutTypeTagName {
	POSTPAID = "Comprar Bolsa", // Pós pago
	PREPAID = "Inscrição Premium", // Pré pago
	PREPAID_FINISHED = "Bolsa Garantida!", // Pré pago
	PREPAID_GUARANTEE = "Garantindo sua bolsa", // Pré pago
	SUBSCRIPTION = "Inscrição Gratuita", // Inscrição
}